import { useEffect, useState } from 'react';
import DocumentMeta from 'react-document-meta';
import StateCoverageGroupedSearch from '../components/StateCoverage/StateCoverageGroupedSearch';

import config from '../config';

const meta = {
  title: 'Home | Free Medication Abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'Home | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function Home() {
  const [cmsData, setCmsData] = useState(undefined);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/Homepage`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result._id) {
          console.log(result);
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    fetchData();
  }, []);

  if (!cmsData) {
    return null;
  }

  return (
    <DocumentMeta {...meta}>
      <section id="hero" className="hero section border-0">
        <div className="container py-lg-5">
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-12">
                <h1 className="my-3">{cmsData.Title || ''}</h1>
                <h3>{cmsData.Tagline || ''}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section py-0">
        <div className="container section-title pt-3 pb-0">
          <div
            className="row gy-4"
            dangerouslySetInnerHTML={{ __html: cmsData.Section1 || '' }}
          ></div>
        </div>
      </section>

      <StateCoverageGroupedSearch title="2. SELECT YOUR STATE" />

      <section className="section py-0">
        <div className="container section-title pt-3 pb-0">
          <div className="row gy-4">
            <div
              className="col-lg-8 col-md-8 col-12"
              dangerouslySetInnerHTML={{ __html: cmsData.Section2 || '' }}
            ></div>
          </div>
        </div>
      </section>

      <section className="section py-0 light-background">
        <div className="container section-title py-0" data-aos="fade-up">
          <p className="text-muted bg-light p-2 rounded"></p>
        </div>
      </section>
    </DocumentMeta>
  );
}
